import { z } from 'zod';

import { evaluationSchema } from '@/schemas/judges';
import type { ZodUseMutation, ZodUseQuery } from '@/utils/zodReactQuery';

export const conversationEvaluationsResponse = z.object({
	items: z.array(evaluationSchema),
	status: z.enum(['pending', 'completed', 'not_applicable']),
	totalApplicable: z.number().int().nonnegative(),
});
export type ConversationEvaluationsResponse = z.infer<typeof conversationEvaluationsResponse>;

export const evaluationRunSchema = z.object({
	threadId: z.string(),
	moduleName: z.string(),
	agentName: z.string(),
	userName: z.string(),
	companyName: z.string(),
	verdict: evaluationSchema,
});
export type EvaluationRun = z.infer<typeof evaluationRunSchema>;

export const evaluationsListResponse = z.object({
	items: z.array(evaluationRunSchema),
	pagination: z.object({
		page: z.number().int().positive(),
		pageSize: z.number().int().positive(),
		totalItems: z.number().int().nonnegative(),
		totalPages: z.number().int().nonnegative(),
	}),
});
export type EvaluationsListResponse = z.infer<typeof evaluationsListResponse>;

export const evaluationsParamsSchema = z
	.object({
		page: z.number().int().positive().optional(),
		pageSize: z.number().int().positive().optional(),
		judgeId: z.string().optional(),
		verdict: z.enum(['passed', 'failed']).optional(),
		moduleName: z.string().optional(),
	})
	.partial();
export type EvaluationsParams = z.infer<typeof evaluationsParamsSchema>;

export type UseConversationEvaluations = ZodUseQuery<ConversationEvaluationsResponse, { threadId: string }>;
export type UseEvaluations = ZodUseQuery<EvaluationsListResponse, EvaluationsParams>;
export type UseRunEvaluations = ZodUseMutation<ConversationEvaluationsResponse, { threadId: string }>;
